import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-clipboard-check-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M6.895 1.442a1.033 1.033 0 00-1.03.96h4.27a1.031 1.031 0 00-1.03-.96h-2.21zm-2.031-.01a2.282 2.282 0 012.03-1.24h2.211c.886 0 1.652.503 2.031 1.24.354.03.706.066 1.057.106 1.142.133 1.958 1.113 1.958 2.23v9.758a2.283 2.283 0 01-2.283 2.283H4.132a2.283 2.283 0 01-2.283-2.283V3.769c0-1.118.816-2.098 1.958-2.23.35-.041.703-.077 1.057-.108zm-.229 1.276c-.228.021-.457.046-.684.072a.98.98 0 00-.852.989v9.757c0 .57.463 1.033 1.033 1.033h7.736c.57 0 1.033-.463 1.033-1.033V3.769a.98.98 0 00-.852-.989c-.227-.026-.455-.05-.684-.072a1.178 1.178 0 01-1.155.944H5.79c-.57 0-1.047-.406-1.155-.945zm6.524 3.24c.287.192.365.58.173.867l-3.374 5.063a.625.625 0 01-.962.095l-2.25-2.25a.625.625 0 11.883-.884L7.34 10.55l2.953-4.428a.625.625 0 01.866-.173z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const ClipboardCheckIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
ClipboardCheckIcon.displayName = 'ClipboardCheckIcon';